export const RECIPIENT_LEVELS = ['P', 'C', 'R'] as const
export type RecipientLevel = (typeof RECIPIENT_LEVELS)[number]

export function selectRecipientLevel(
  levels?: Array<string | null | undefined> | null,
  parentUei?: string | null,
): RecipientLevel {
  const normalized = (levels ?? [])
    .map((level) => level?.toUpperCase())
    .filter((level): level is RecipientLevel =>
      level ? (RECIPIENT_LEVELS as readonly string[]).includes(level) : false,
    )

  for (const level of ['C', 'R', 'P'] as const) {
    if (normalized.includes(level)) return level
  }

  if (parentUei && parentUei !== 'NULL') return 'C'
  return 'R'
}

export function buildRecipientId(
  hash: string | null | undefined,
  level?: string | null,
): string | null {
  if (!hash) return null

  // Already in {hash}-{level} format
  if (/[\\-](P|C|R)$/.test(hash)) return hash

  const normalized =
    level && RECIPIENT_LEVELS.includes(level.toUpperCase() as RecipientLevel)
      ? (level.toUpperCase() as RecipientLevel)
      : 'R'

  return `${hash}-${normalized}`
}
